import { Environment } from '../../Environment';

export function getLaunchDarklyClientId(env: Environment): string {
  switch (env) {
    case Environment.STAGING:
    case Environment.TESTING:
    case Environment.EPHEMERAL:
      // If you're here, you're debugging code running on a hostname matching
      // either STAGING, TESTING, or EPHEMERAL environment, but that somehow, we don't have
      // the REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING env var set. That's either
      // a problem with the build process, or the hostname configuration of
      // getEnvironment.
      return (
        process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING ||
        'missing-REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING-see-code-comment'
      );
    case Environment.PRODUCTION:
      // If you're here, you're debugging code running on a hostname matching
      // the PRODUCTION Environment, but that somehow, we don't have the
      // REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION env var set. That's either a
      // problem with the build process, or the hostname configuration of
      // getEnvironment.
      return (
        process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION ||
        'missing-REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION-see-code-comment'
      );
    case Environment.LOCAL:
      // If this string turns up in your debugging, it's likely the code you're
      // debugging accidentally depended on our LaunchDarkly integration in a
      // test or development enviroment it wasn't expected to run in. Likely you
      // want to either: adjust getEnvironment's hostname configuration; or
      // adjust how ConfiguredFeatureFlagProvider interprets the Environment
      // enums.
      return 'fake-client-id-for-Environment.LOCAL-see-code-comment';
    case Environment.UNKNOWN:
    default:
      // If this string turns up in your debugging, it's likely the code you're
      // debugging accidentally depended on our LaunchDarkly integration in a
      // test or development enviroment it wasn't expected to run in. Likely you
      // want to either: mock out the ConfiguredFeatureFlagProvider's LDClient
      // because you're writing unit tests for it; mock out
      // ConfiguredFeatureFlagProvider; or adjust getEnvironment's hostname
      // configuration.
      return 'fake-client-id-for-Environment.UNKNOWN-see-code-comment';
  }
}
